(() => {
  if (window.OlouiooDuration) return;
  const settings = new WeakMap();
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  let busy = false;
  const groupId = () => typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(16).slice(2);
  function control(node) { return node?.matches?.('[data-hire-options]') ? node : node?.querySelector('[data-hire-options]'); }
  function config(node) {
    const element = control(node);
    if (!element) return null;
    if (!settings.has(element)) {
      settings.set(element, JSON.parse(element.querySelector('[data-hire-config]').textContent));
      const hours = Number(element.dataset.currentHours);
      if (hours) setDuration(element, hours, settings.get(element).mode, true);
    }
    return settings.get(element);
  }
  function selection(node) {
    const element = control(node), data = config(element);
    if (!element || !data) return null;
    const select = element.querySelector('[data-hire-duration]');
    const option = select.selectedOptions[0];
    const hours = Number(select.value);
    const allowed = data.mode === 'self' ? [6,24,48,72].includes(hours) || option?.hasAttribute('data-hire-legacy') : (hours >= 3 && hours <= 13) || hours === 24 || hours === 48;
    if (!option || option.disabled || !Number.isInteger(hours) || !allowed) throw new Error(data.error);
    const variant = Number(option.dataset.variantId) || null;
    const components = option.dataset.components ? JSON.parse(option.dataset.components) : variant ? [{id:variant,quantity:1}] : [];
    const price = Number(option.dataset.price);
    if (!Number.isFinite(price) || price < 0 || !Array.isArray(components) || components.some(item => !Number.isSafeInteger(item.id) || item.id <= 0 || !Number.isSafeInteger(item.quantity) || item.quantity < 1)) throw new Error(data.error);
    return { hours, label: option.textContent.trim(), price, components, legacy:option.hasAttribute('data-hire-legacy'), config: data };
  }
  function setDuration(node, hours, mode, legacy = false) {
    const element = control(node), data = config(element);
    if (!element || !data) return;
    const select = element.querySelector('[data-hire-duration]');
    mode = mode || data.mode || 'hourly';
    if (!['self','hourly'].includes(mode)) throw new Error(data.error);
    if (data.mode !== mode) {
      const template = element.querySelector('template[data-hire-mode="' + mode + '"]');
      if (!template) throw new Error(data.error);
      select.replaceChildren(template.content.cloneNode(true));
      data.mode = mode;
    }
    data.baseHours = mode === 'self' ? 6 : 3;
    let option = [...select.options].find(item => Number(item.value) === Number(hours));
    if (!option && legacy && hours >= 3 && hours <= 13) {
      const previous = element.querySelector('template[data-hire-mode="hourly"]')?.content.querySelector('option[value="' + Number(hours) + '"]');
      if (previous) {
        option = previous.cloneNode(true);
        option.setAttribute('data-hire-legacy','');
        option.textContent += ' · ' + data.legacyLabel;
        select.prepend(option);
      }
    }
    if (!option || option.disabled && !legacy) throw new Error(data.error);
    select.value = option.value;
    const hint = element.querySelector('[data-hire-hint]');
    if (hint) hint.textContent = hint.dataset[mode];
  }
  const cost = node => selection(node)?.price || 0;
  function schedule(properties, hours, nextDay) {
    const date = properties['Event date'], time = properties['Start time'];
    return { ...properties, ...(date && time ? window.OlouiooEvents?.schedule({ date, time }, nextDay, hours) : {}), '_olouioo_duration_hours': String(hours), 'Hire duration': hours + ' hours', 'Event duration': hours + ' hours active hire' };
  }
  function extend(node, items, group, station = false) {
    const selected = selection(node);
    if (!selected) return items;
    if (selected.hours !== (selected.config.baseHours || 3) && !selected.components.length && !selected.legacy) throw new Error(selected.config.error);
    items.forEach(item => { item.properties = { ...schedule(item.properties || {}, selected.hours, selected.config.nextDay), ...(selected.hours >= 24 ? { 'Hire duration': selected.label } : {}), '_olouioo_hire_group': group, '_olouioo_duration_mode':selected.config.mode || 'hourly' }; });
    for (const component of selected.components) {
      const properties = { ...items[0].properties, '_olouioo_duration_component': 'true', 'Linked service': selected.config.title };
      delete properties.Garnishes;
      delete properties['Water-service guests'];
      delete properties['Water style'];
      if (station) properties._olouioo_refreshment_group = group;
      else delete properties._olouioo_refreshment_group;
      items.push({ id: component.id, quantity: component.quantity, properties });
    }
    return items;
  }
  function productItems(owner, data) {
    const scope = owner.closest('.product-information') || document.querySelector('.product-information product-form-component[data-product-id="' + owner.dataset.productId + '"]')?.closest('.product-information');
    const booking = owner.querySelector('event-booking-fields') || scope?.querySelector('.buy-buttons-block event-booking-fields');
    if (!control(booking)) return null;
    const properties = {};
    for (const [name, value] of data.entries()) {
      const match = name.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    }
    const item = { id: Number(data.get('id')), quantity: Number(data.get('quantity')), properties };
    if (data.get('selling_plan')) item.selling_plan = Number(data.get('selling_plan'));
    return extend(booking, [item], groupId());
  }
  async function request(path, body, message) {
    const response = await fetch(rootUrl() + path, { cache:'no-store', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, ...(body ? { method:'POST', body:JSON.stringify(body) } : {}) });
    const result = await response.json();
    if (!response.ok || result.status || result.errors) throw new Error(typeof result.description === 'string' ? result.description : message);
    return result;
  }
  function displayCount(items) {
    const groups = new Set();
    return (items || []).reduce((total, item) => {
      if (item.properties?._olouioo_duration_component === 'true') return total;
      if (String(item.product_id ?? item.product?.id) === '7740771991686') {
        const group = item.properties?._olouioo_refreshment_group || item.key;
        if (groups.has(group)) return total;
        groups.add(group);
        return total + 1;
      }
      return total + Number(item.quantity || 0);
    }, 0);
  }
  function belongs(item, row) {
    return item.properties?._olouioo_hire_group === row.dataset.hireGroup || (!item.properties?._olouioo_hire_group && item.key === row.dataset.key);
  }
  async function replace(row, items, sections, data) {
    const current = await request('cart.js', null, data.error);
    if (!current.items.some(item => belongs(item, row))) throw new Error(data.changed);
    const group = items[0].properties._olouioo_hire_group;
    const added = item => item.properties?._olouioo_hire_group === group;
    try {
      await request('cart/add.js', { items }, data.error);
      const fresh = await request('cart.js', null, data.error);
      const old = fresh.items.filter(item => belongs(item, row));
      if (!old.length) throw new Error(data.changed);
      return await request('cart/update.js', { updates:Object.fromEntries(old.map(item => [item.key, 0])), sections, sections_url:location.pathname }, data.error);
    } catch (error) {
      const latest = await request('cart.js', null, data.error).catch(() => null);
      if (!latest) throw new Error(data.recovery);
      if (!latest.items.some(item => belongs(item, row)) && latest.items.some(added)) return request('cart/update.js', { updates:{}, sections, sections_url:location.pathname }, data.error);
      const newItems = latest.items.filter(added);
      if (newItems.length) {
        try { await request('cart/update.js', { updates:Object.fromEntries(newItems.map(item => [item.key, 0])) }, data.error); }
        catch { throw new Error(data.recovery); }
      }
      throw error;
    }
  }
  function productTotal(element) {
    if (element.hasAttribute('data-hire-cart-options')) return;
    const scope = element.closest('.product-information');
    if (!scope || element.closest('[data-rfs-root]')) return;
    const owner = scope.querySelector('.buy-buttons-block product-form-component');
    const quantity = Number(owner?.querySelector('[name=quantity]')?.value) || 1;
    const data = config(element);
    const total = (data.basePrice * quantity + cost(element)) / 100;
    const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style:'currency', currency:data.currency }).format(total);
    scope.querySelectorAll('product-form-component .add-to-cart-price').forEach(price => { if (price.textContent !== ' - ' + formatted) price.textContent = ' - ' + formatted; });
  }
  function paint(scope = document) { scope.querySelectorAll('[data-hire-options]:not([data-hire-cart-options])').forEach(productTotal); }
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-hire-duration]')) return;
    const booking = event.target.closest('event-booking-fields');
    if (booking) {
      booking.querySelector('[data-event-duration]')?.setAttribute('value', event.target.value + ' hours active hire');
      booking.querySelector('[data-start-time]')?.dispatchEvent(new Event('input', { bubbles:true }));
    }
    paint();
    event.target.dispatchEvent(new CustomEvent('olouioo:duration-change', { bubbles:true }));
  });
  for (const name of ['input', 'quantity-selector:update']) document.addEventListener(name, event => { if (event.target.closest('.product-information')) requestAnimationFrame(() => paint()); });
  for (const name of ['variant:update', 'olouioo:service-variant']) document.addEventListener(name, event => {
    const variant = event.detail?.resource || event.detail?.variant;
    if (!variant) return;
    const scope = event.target.closest('.product-information');
    if (!scope) return;
    scope.querySelectorAll('[data-hire-options]').forEach(element => { config(element).basePrice = variant.price; });
    requestAnimationFrame(() => paint(scope));
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-hire-save],[data-hire-remove]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || button.disabled) return;
    const row = button.closest('[data-hire-group]');
    const error = row.querySelector('[data-hire-error]');
    const data = config(row);
    if (!data) return;
    const controls = [...document.querySelectorAll('cart-items-component button,cart-items-component input,cart-items-component select')].map(input => [input, input.disabled]);
    busy = true;
    error.hidden = true;
    row.setAttribute('aria-busy', 'true');
    controls.forEach(([input]) => { input.disabled = true; });
    let announcement;
    try {
      const { announceCartLinesUpdate, settleWithCart } = await import('@theme/standard-cart-events');
      const { CartUpdateEvent } = await import('@theme/events');
      const current = await request('cart.js', null, data.error);
      const old = current.items.filter(item => belongs(item, row));
      if (!old.length) throw new Error(data.changed);
      const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(component => component.dataset.sectionId).filter(Boolean))].slice(0, 5);
      const removing = button.hasAttribute('data-hire-remove');
      announcement = announceCartLinesUpdate(row, { action:removing ? 'remove' : 'update', context:'cart', lines:old.map(item => ({ id:item.key, quantity:removing ? 0 : item.quantity })) });
      let cart;
      if (removing) cart = await request('cart/update.js', { updates:Object.fromEntries(old.map(item => [item.key, 0])), sections, sections_url:location.pathname }, data.error);
      else {
        const parent = old.find(item => item.properties?._olouioo_duration_component !== 'true');
        if (!parent) throw new Error(data.changed);
        const items = extend(row, [{ id:parent.variant_id, quantity:parent.quantity, properties:{ ...parent.properties } }], groupId());
        cart = await replace(row, items, sections, data);
      }
      document.dispatchEvent(new CartUpdateEvent({}, 'service-duration', { source:'service-duration', items:cart.items, itemCount:cart.item_count, sections:cart.sections, autoOpenDrawer:false }));
      settleWithCart(announcement, cart, { source:'service-duration', sections:cart.sections });
    } catch (failure) {
      announcement?.reject(failure);
      error.textContent = failure.message || data.error;
      error.hidden = false;
    } finally {
      busy = false;
      row.removeAttribute('aria-busy');
      controls.forEach(([input, disabled]) => { input.disabled = disabled; });
    }
  }, true);
  window.OlouiooDuration = { cost, productItems, extend, displayCount, schedule, setDuration, mode:node => config(node)?.mode };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => paint());
  else paint();
  document.addEventListener('shopify:section:load', () => paint());
})();

